import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchProducts } from "../../store/products"
import { Doughnut, Bar } from "react-chartjs-2"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from "chart.js"
import "../styles/AdminCharts.css"

// Register components for Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  ArcElement,
  BarElement,
  Title,
  Tooltip,
  Legend
)

const initialChartData = {
  labels: [],
  datasets: [
    {
      label: "",
      data: [],
      backgroundColor: [],
      borderColor: [],
      borderWidth: 1,
    },
  ],
}

const AdminProductChart = () => {
  const dispatch = useDispatch()
  const products = useSelector((state) => state.products.products)
  const [categoryChartData, setCategoryChartData] = useState(initialChartData)
  const [materialChartData, setMaterialChartData] = useState(initialChartData)
  const [priceChartData, setPriceChartData] = useState(initialChartData)

  useEffect(() => {
    dispatch(fetchProducts())
  }, [dispatch])

  useEffect(() => {
    if (products.length) {
      const categoryData = {}
      const materialData = {}
      const priceData = {}

      products.forEach((product) => {
        // Accumulating category data
        if (product.category) {
          categoryData[product.category] =
            (categoryData[product.category] || 0) + 1
        }
        // Accumulating material data
        if (product.material) {
          materialData[product.material] =
            (materialData[product.material] || 0) + 1
        }
        // Accumulating price data
        if (!priceData[product.category]) {
          priceData[product.category] = []
        }
        priceData[product.category].push(product.price)
      })

      // Setting category chart data
      setCategoryChartData({
        labels: Object.keys(categoryData),
        datasets: [
          {
            label: "Products per Category",
            data: Object.values(categoryData),
            backgroundColor: generateColorArray(Object.keys(categoryData), 0.5),
            borderColor: generateColorArray(Object.keys(categoryData), 1),
          },
        ],
      })

      // Setting material chart data
      setMaterialChartData({
        labels: Object.keys(materialData),
        datasets: [
          {
            label: "Products per Material",
            data: Object.values(materialData),
            backgroundColor: generateColorArray(Object.keys(materialData), 0.5),
            borderColor: generateColorArray(Object.keys(materialData), 1),
          },
        ],
      })

      // Processing and setting price chart data
      const priceAvgData = {}
      Object.keys(priceData).forEach((category) => {
        const total = priceData[category].reduce((a, b) => a + parseFloat(b), 0)
        const average = total / priceData[category].length
        priceAvgData[category] = average
      })

      setPriceChartData({
        labels: Object.keys(priceAvgData),
        datasets: [
          {
            label: "Average Price per Category",
            data: Object.values(priceAvgData),
            backgroundColor: generateColorArray(Object.keys(priceAvgData), 0.5),
            borderColor: generateColorArray(Object.keys(priceAvgData), 1),
          },
        ],
      })
    }
  }, [products])

  const generateColorArray = (keys, opacity) => {
    const baseColors = [
      [76, 175, 80],
      [178, 178, 178],
      [255, 99, 132],
      [54, 162, 235],
      [255, 159, 64],
      [201, 203, 207],
      [153, 102, 255],
    ]
    return keys.map((_, index) => {
      const color = baseColors[index % baseColors.length]
      return `rgba(${color.join(", ")}, ${opacity})`
    })
  }

  return (
    <div className="myChart-container">
      <div className="chart-container">
        <h3>Categories</h3>
        <Doughnut data={categoryChartData} className="myChart-canvas" />
      </div>
      <div className="chart-container">
        <h3>Materials</h3>
        <Doughnut data={materialChartData} className="myChart-canvas" />
      </div>
      <div className="chart-container">
        <h3>Average Price by Category</h3>
        <Bar
          data={priceChartData}
          className="barChart-canvas"
          options={{ indexAxis: "y" }}
        />
      </div>
    </div>
  )
}

export default AdminProductChart
